import { render, staticRenderFns } from "./BankListAutoWithdrawalAff.vue?vue&type=template&id=084494d8&lang=pug"
import script from "./BankListAutoWithdrawalAff.vue?vue&type=script&lang=js"
export * from "./BankListAutoWithdrawalAff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports